import { types, actions } from './requests'
export const CREATEITEM_TYPES = {
    ...types('CREATEITEM'),
}
export const CREATEITEM_ACTIONS = {
    ...actions('CREATEITEM'),
}
